import * as React from 'react';
import gettext from '@sdk/lang/gettext';

import SettingsSection from '../../../settings/components/SettingsSection';
import SettingsSwitcherRow from '../../../settings/components/SettingsSwitcherRow';

import { ClockInEnabledField, ClockInFromWebAndAppsField } from './types/TimeclockFields';

type Props = {
  clockInFromWebAndApps: ClockInFromWebAndAppsField;
  clockInEnabled: ClockInEnabledField;
};

const TimeTracking: React.FC<React.PropsWithChildren<Props>> = ({
  clockInFromWebAndApps,
  clockInEnabled,
}) => {
  return (
    <SettingsSection withSeparator pTop={20}>
      <SettingsSwitcherRow
        title={gettext('Time tracking')}
        subtitle={gettext('Enable time tracking through the Sling app')}
        value={clockInFromWebAndApps.value && clockInEnabled.value}
        onChange={(value): void => {
          clockInFromWebAndApps.onChange(value);
          clockInEnabled.onChange(value);
        }}
      />
    </SettingsSection>
  );
};

export default TimeTracking;
